// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The tinted strip spans the viewport; the text inside lines up with the
   page content instead of the window edge. */
.team-status-banner {
  font-size: 0.9rem;
  color: var(--text-color);
  margin-bottom: 1rem;
}

/* Same 948px/24px box as .header-menu, and it follows the active route's
   shell the same way — full-bleed on wide (workspace) routes, constrained
   everywhere else — so the banner never disagrees with the page under it. */
.team-status-banner-content {
  width: 100%;
  max-width: 948px;
  margin-inline: auto;
  padding: 8px 24px;
  box-sizing: border-box;
}

html[data-shell-variant='wide'] .team-status-banner-content {
  max-width: none;
}

.team-status-banner a {
  color: inherit;
  font-weight: 600;
  text-decoration: underline;
}

.team-status-banner-trial {
  background: var(--accent-tint);
  color: var(--accent-tint-text);
}

.team-status-banner-warning {
  background-color: var(--warning-bg);
  border-bottom: 1px solid var(--warning-border);
}
`, "",{"version":3,"sources":["webpack://./src/billing/TeamStatusBanner.css"],"names":[],"mappings":"AAAA;6CAC6C;AAC7C;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;;4EAE4E;AAC5E;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;AAChD","sourcesContent":["/* The tinted strip spans the viewport; the text inside lines up with the\n   page content instead of the window edge. */\n.team-status-banner {\n  font-size: 0.9rem;\n  color: var(--text-color);\n  margin-bottom: 1rem;\n}\n\n/* Same 948px/24px box as .header-menu, and it follows the active route's\n   shell the same way — full-bleed on wide (workspace) routes, constrained\n   everywhere else — so the banner never disagrees with the page under it. */\n.team-status-banner-content {\n  width: 100%;\n  max-width: 948px;\n  margin-inline: auto;\n  padding: 8px 24px;\n  box-sizing: border-box;\n}\n\nhtml[data-shell-variant='wide'] .team-status-banner-content {\n  max-width: none;\n}\n\n.team-status-banner a {\n  color: inherit;\n  font-weight: 600;\n  text-decoration: underline;\n}\n\n.team-status-banner-trial {\n  background: var(--accent-tint);\n  color: var(--accent-tint-text);\n}\n\n.team-status-banner-warning {\n  background-color: var(--warning-bg);\n  border-bottom: 1px solid var(--warning-border);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
